import createActionTypes from './createActionTypes';

export const namespace = 'ROUTER';

export const types = createActionTypes(namespace, [
  'UPDATE_QUERY',
  'UPDATE_GEOLOCATION',
  'SET_GCLID_DEPENDENCIES_READY',
  // "SET_STORE_ID_READING_READY",
]);

export const updateQuery = (query) => {
  return {
    type: types.UPDATE_QUERY,
    payload: {
      query,
    },
  };
};

export const updateGeolocation = (geolocation) => {
  return {
    type: types.UPDATE_GEOLOCATION,
    payload: {
      geolocation,
    },
  };
};

export const setGclidDependenciesReady = () => ({
  type: types.SET_GCLID_DEPENDENCIES_READY,
});

// export const setStoreIdReadingReady = () => ({
//   type: types.SET_STORE_ID_READING_READY,
// });
